import moment from 'moment';

// check if interval is les than x days
export const checkIntervalDiff = (interval, maxDiff) => {
  try {
    const diff = getIntervalDiff(interval);
    return diff < maxDiff
  } catch (err) {
    // ignore
  }
  return true;
}

export const getIntervalDiff = (interval) => {
  try {
    if (interval) {
      const from = moment(interval.from);
      const to = moment(interval.to);
      if (from.isValid() && to.isValid()) {
        const diff = to.diff(from, 'days') + 1; // our windows ends in the same day
        return diff;
      }
    }
  } catch (err) {
    // ignore
  }
  return 0;
}

// duration in seconds for message text
// placeholder in case we need to calculate based on metric gateway logic
export const calcProgressDuration = (duration = 0) => {
  const base = Math.min(25 + duration, 300);
  return base;
}

export const secondsToMinutes = (time) => {
  try {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    if(minutes > 0) {
      return `${minutes} minutes` + (seconds > 0 ? ` ${seconds} seconds` : '');
    }
    return `${seconds} seconds`;
  }
  catch (err) {
    // ignore
  }
  return '20s'; // default
}
